import { render, staticRenderFns } from "./ModalEmbalagens.vue?vue&type=template&id=1089b2c4&scoped=true&"
import script from "./ModalEmbalagens.vue?vue&type=script&lang=js&"
export * from "./ModalEmbalagens.vue?vue&type=script&lang=js&"
import style0 from "./ModalEmbalagens.vue?vue&type=style&index=0&id=1089b2c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1089b2c4",
  null
  
)

export default component.exports